(() => {
  const initialise = (root) => {
    if (!root || root.dataset.stockistsReady === 'true') return;
    root.dataset.stockistsReady = 'true';

    const input = root.querySelector('[data-stockist-search]');
    const cards = [...root.querySelectorAll('[data-stockist-card]')];
    const regionSections = [...root.querySelectorAll('[data-stockist-region-section]')];
    const serviceButtons = [...root.querySelectorAll('[data-stockist-service]')];
    const regionButtons = [...root.querySelectorAll('[data-stockist-region-button]')];
    const clearButtons = [...root.querySelectorAll('[data-stockist-clear]')];
    const noResults = root.querySelector('[data-stockist-no-results]');
    const resultCount = root.querySelector('[data-stockist-result-count]');

    let activeService = 'all';
    let activeRegion = 'all';

    const normalise = (value) => (value || '').toLocaleLowerCase().trim();

    const updateButtons = () => {
      serviceButtons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.stockistService === activeService);
      });
      regionButtons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.stockistRegionButton === activeRegion);
      });
    };

    const apply = () => {
      const query = normalise(input?.value);
      let visibleCount = 0;

      cards.forEach((card) => {
        const searchMatches = !query || normalise(card.dataset.search).includes(query);
        const serviceMatches = activeService === 'all' || normalise(card.dataset.services).split(/\s+/).includes(activeService);
        const regionMatches = activeRegion === 'all' || card.dataset.region === activeRegion;
        const visible = searchMatches && serviceMatches && regionMatches;
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      regionSections.forEach((section) => {
        const hasVisible = [...section.querySelectorAll('[data-stockist-card]')].some((card) => !card.hidden);
        section.hidden = !hasVisible;
      });

      if (noResults) noResults.hidden = cards.length === 0 || visibleCount > 0;
      if (resultCount && cards.length > 0) {
        resultCount.textContent = `${visibleCount} location${visibleCount === 1 ? '' : 's'} shown`;
      }
      updateButtons();
    };

    input?.addEventListener('input', apply);

    serviceButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeService = button.dataset.stockistService || 'all';
        apply();
      });
    });

    const selectRegion = (region) => {
      activeRegion = activeRegion === region ? 'all' : region;
      apply();
      if (activeRegion !== 'all') {
        const section = root.querySelector(`[data-stockist-region-section="${activeRegion}"]`);
        if (section && !section.hidden) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    regionButtons.forEach((button) => {
      const handler = () => selectRegion(button.dataset.stockistRegionButton || 'all');
      button.addEventListener('click', handler);
      if (button.tagName.toLowerCase() !== 'button') {
        button.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handler();
          }
        });
      }
    });

    clearButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (input) input.value = '';
        activeService = 'all';
        activeRegion = 'all';
        apply();
      });
    });

    apply();
  };

  const initialiseAll = () => document.querySelectorAll('[data-stockists-directory]').forEach(initialise);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', initialiseAll);
})();
